import { Component, OnInit } from '@angular/core';
import { ApiProvider } from '../../../@core/providers/api.provider';
import { environment } from '../../../../environments/environment';
import { HttpErrorResponse } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

@Component({
  selector: 'expedier-member',
  templateUrl: './expedier-member.component.html',
  styleUrls: ['./expedier-member.component.scss']
})
export class ExpedierMemberComponent implements OnInit {

  public NameEdit: string;
  public Address1Edit: string;
  public Address2Edit: string;
  public VilleEdit: string;
  public CodePostalEdit: string;
  public TelEdit: string;
  public PosteEdit: string;
  public NameEditPickLiv: string;
  public Address1EditPickLiv: string;
  public Address2EditPickLiv: string;
  public CodePostalEditPickLiv: string;
  public PosteEditPickLiv: string;
  public contact_email: string;
  public RefEdit: string;

  public VilleEditPickLiv: string;
  public TelEditPickLiv: string;



  public _sequenceID: number;
  public _customerID: number;
  public _ncAccount: string;

  public dateF:any=new Date();
  public dateString: string;
  public dayDate: Date;

  constructor(
    public apiProvider: ApiProvider,
    public datePipe: DatePipe) { }

  ngOnInit() {
    if(environment.apiUrl == 'https://fred.nationex.com/' || environment.apiUrl == 'https://localhost:53319/'){
      this.NameEdit = 'Fred qui test';
      this.Address1Edit = '5425 St-Jean';
      this.Address2Edit = 'Fred qui test';
      this.VilleEdit = 'Sainte-Catherine';
      this.CodePostalEdit = 'J5C1K7';
      this.TelEdit = '5147027313';
      this.contact_email = 'flamarche@nationex.com';
    }
    this.dayDate = new Date();
    this.dateString = this.dayDate.toISOString();
    this.dateF = this.datePipe.transform(this.dayDate, 'yyyy-MM-dd');
  }

  public changeDate(event: MatDatepickerInputEvent<Date>) {
    this.dayDate = event.value;
  }

  public insertClick() {
    this.apiProvider.InsertConsignee(this._sequenceID, this._customerID, this._ncAccount, this.NameEdit, this.Address1Edit, this.Address2Edit,
      this.VilleEdit, 'QC', this.CodePostalEdit, this.TelEdit, this.contact_email).subscribe((sequenceID: number) => {
        this._sequenceID = sequenceID;
      }, (err: HttpErrorResponse) => {
        this._sequenceID = 0;
      });
  }
}
